import React from 'react';
import LoadMeasurementComponent from './LoadMeasurementComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getModel } from './selectors';
import * as actions from './actions';

const LoadMeasurementContainer = (props) => {
    return <LoadMeasurementComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const LoadMeasurementContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoadMeasurementContainer);

export default LoadMeasurementContainerConn;
